import React, { useState, useEffect } from "react";
import { Col, Row, Card, ProgressBar, Form, Button } from "react-bootstrap";
import UploadVideo from "./UploadVideo";
import axios from "axios";
import { FaRedoAlt } from "react-icons/fa";


const RescueUpload = ({
	family,
	fields,
	formState,
	businessTypes,
	donors,
	handleFileChange,
	setFormState,
	handleChange,
	rescueData,
	handleSubmit,
	handleSubmitBusiness,
}) => {
	const [businessFormState, setBusinessFormState] = useState({
		...formState,
	});

	const [activeSection, setActiveSection] = useState("family");
	const loanFields = [
		{ field: "loan_file", text: "Loan File", icon: "payments" },
		{ field: "khatta_file", text: "Khatta File", icon: "checklist_rtl" },
		{
			field: "medical_file",
			text: "Medical File",
			icon: "medical_information",
		},
		{ field: "food_file", text: "Food File", icon: "restaurant" },
		{ field: "utility_file", text: "Utility File", icon: "receipt_long" },
		{ field: "rent_file", text: "Rent File", icon: "real_estate_agent" },
		{
			field: "transportation_file",
			text: "Transportation File",
			icon: "airport_shuttle",
		},
		{ field: "other_file", text: "Other File", icon: "dynamic_feed" },
		{ field: "meal_file", text: "Meal File", icon: "dynamic_feed" },

		{
			field: "khatta_unpaid_invoice",
			text: "khatta unpaid invoice",
			icon: "dynamic_feed",
		},

		{ field: "meal_file_rc", text: "Meal File Rc", icon: "dynamic_feed" },

		{
			field: "medical_file_rc",
			text: "Medical File Rc",
			icon: "dynamic_feed",
		},

		{
			field: "transportation_file_rc",
			text: "Transportation File Rc",
			icon: "dynamic_feed",
		},
		{
			field: "unpaid_loan_invoice",
			text: "Unpaid Loan Invoice",
			icon: "dynamic_feed",
		},

		{
			field: "utility_amount",
			text: "Utility Amount",
			icon: "dynamic_feed",
		},
	];
	const businessFields = [
		{ field: "equipment_cost_file", text: "Equipment Cost File" },
		{ field: "business_img", text: "Business Image" },
		{ field: "business_deed_img", text: "Business Deed Image" },
		{ field: "family_with_business", text: "Family with Business" },
	];

	const familyPics = [
		{ field: "affidavit", text: "Affidavit" },
		{ field: "relocation_img", text: "Relocation Image" },
		{ field: "new_home_img", text: "New Home Image" },
		{ field: "release_img", text: "Release Image" },
		{ field: "family_check_img", text: "Family Check Image" },
		{ field: "family_working_img", text: "Family Working Image" },

		{ field: "img_1", text: "Family Picture" },
		{ field: "img_2", text: "Family Picture" },
		{ field: "img_3", text: "Family Picture" },
		{ field: "img_4", text: "Family Picture" },
		{ field: "img_5", text: "Family Picture" },
		{ field: "img_6", text: "Family Picture" },
	];

	const renderContent = () => {
		if (activeSection === "story") {
			return (
				<>
					<Col
						md={12}
						className="mb-4"
					>
						<Form.Group
							as={Col}
							md="12"
							controlId={`story-1`}
						>
							<Form.Label>Family Story</Form.Label>
							<Form.Control
								as="textarea"
								onChange={handleChange}
								name="family_story"
								placeholder="Enter Family Story Here..."
								rows={40}
								value={rescueData?.family_story}
							/>
						</Form.Group>
					</Col>
					<Col
						md={12}
						className="mb-4"
					>
						<Button
							color="primary"
							onClick={handleSubmit}
							className="w-100"
						>
							Save Family Story
						</Button>
					</Col>
				</>
			);
		} else if (activeSection === "pictures") {
			return familyPics.map((field) => (
				<Col
					key={field.field}
					md={4}
					className="mb-4"
				>
					<Card>
						<Card.Body>
							<Card.Title>
								<small>{field.text}</small>
							</Card.Title>
							<label
								htmlFor={`file-input-${field.field}`}
								style={{
									width: "100%",
									height: "150px",
									border: "1px dashed #ddd",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									marginBottom: "10px",
									cursor: "pointer",
									position: "relative",
								}}
							>
								{formState[field.field]?.preview ||
									family?.person?.[field.field] ? (
									<img
										src={
											formState[field.field].preview ||
											process.env.REACT_APP_IMG_URL +
											family?.person?.[field.field]
										}
										alt={`${field.text} preview`}
										style={{
											maxWidth: "100%",
											maxHeight: "100%",
											objectFit: "cover",
										}}
									/>
								) : (
									<i className="material-icons upload-icon">
										add_photo_alternate
									</i>
								)}
							</label>

							{/* Hidden File Input */}
							<input
								id={`file-input-${field.field}`}
								type="file"
								style={{ display: "none" }}
								onChange={(e) =>
									handleFileChange(
										e,
										field.field,
										activeSection
									)
								}
								accept="image/*"
							/>
						</Card.Body>
					</Card>
				</Col>
			));
		} else if (activeSection === "family") {
			return (
				<>
					<Row>
						<Col
							md={6}
							className="mb-4"
						>
							<Form.Group
								as={Col}
								md="12"
								controlId="name"
							>
								<Form.Label>Name</Form.Label>
								<Form.Control
									type="text"
									name="name"
									onChange={handleChange}
									value={formState?.name || ""}
									placeholder="Enter Name"
								/>
							</Form.Group>
						</Col>

						<Col
							md={6}
							className="mb-4"
						>
							<Form.Group
								as={Col}
								md="12"
								controlId="cnic"
							>
								<Form.Label>CNIC</Form.Label>
								<Form.Control
									type="text"
									name="cnic"
									onChange={handleChange}
									value={formState?.cnic || ""}
									placeholder="Enter CNIC (without dashes or with)"
								/>
							</Form.Group>
						</Col>

						<Col
							md={6}
							className="mb-4"
						>
							<Form.Group
								as={Col}
								md="12"
								controlId="org"
							>
								<Form.Label>Organization</Form.Label>
								<Form.Control
									type="text"
									name="org"
									onChange={handleChange}
									value={formState?.org || ""}
									placeholder="Enter Organization Name"
								/>
							</Form.Group>
						</Col>

						<Col
							md={6}
							className="mb-4"
						>
							<Form.Group
								as={Col}
								md="12"
								controlId="phone"
							>
								<Form.Label>Phone Number</Form.Label>
								<Form.Control
									type="text"
									name="phone"
									onChange={handleChange}
									value={formState?.phone || ""}
									placeholder="Enter Phone Number"
								/>
							</Form.Group>
						</Col>
					</Row>
					{fields.map((field) => (
						<Col
							key={field.field}
							md={12}
							className="mb-4"
						>
							<Card>
								<Card.Body>
									<Card.Title>
										<small>{field.text}</small>
									</Card.Title>
									<label
										htmlFor={`file-input-${field.field}`}
										style={{
											width: "100%",
											height: "150px",
											border: "1px dashed #ddd",
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											marginBottom: "10px",
											cursor: "pointer",
											position: "relative",
										}}
									>
										{formState[field.field]?.preview ||
											family?.person?.[field.field] ? (
											<img
												src={
													formState[field.field]
														.preview ||
													process.env
														.REACT_APP_IMG_URL +
													family?.person?.[
													field.field
													]
												}
												alt={`${field.text} preview`}
												style={{
													maxWidth: "100%",
													maxHeight: "100%",
													objectFit: "cover",
												}}
											/>
										) : (
											<i
												className="material-icons upload-icon"
												style={{ color: "#077834" }}
											>
												{field.icon}
											</i>
										)}
									</label>

									{/* Hidden File Input */}
									<input
										id={`file-input-${field.field}`}
										type="file"
										style={{ display: "none" }}
										onChange={(e) =>
											handleFileChange(
												e,
												field.field,
												activeSection
											)
										}
										accept="image/*"
									/>
								</Card.Body>
							</Card>
						</Col>
					))}
					;
				</>
			);
		} else if (activeSection === "loan") {
			return (
				<>
					<Row>
						<Col
							md={6}
							className="mb-4"
						>
							<Form.Group
								as={Col}
								md="12"
								controlId="affidavit_amount"
							>
								<Form.Label>Affidavit Amount</Form.Label>
								<Form.Control
									type="number"
									name="affidavit_amount"
									onChange={handleChange}
									value={formState?.affidavit_amount || ""}
									placeholder="Enter Affidavit Amount Here..."
								/>
							</Form.Group>
						</Col>

						<Col
							md={6}
							className="mb-4"
						>
							<Form.Group
								as={Col}
								md="12"
								controlId="Est_loan_amount"
							>
								<Form.Label>Est Loan Amount</Form.Label>
								<Form.Control
									type="number"
									name="est_loan_amount"
									onChange={handleChange}
									value={formState?.est_loan_amount}
								/>
							</Form.Group>
						</Col>

						<Col
							md={6}
							className="mb-4"
						>
							<Form.Group
								as={Col}
								md="12"
								controlId="estimated_business_cost"
							>
								<Form.Label>Estimated Business Cost</Form.Label>
								<Form.Control
									type="number"
									name="estimated_business_cost"
									onChange={handleChange}
									value={formState?.estimated_business_cost}
								/>
							</Form.Group>
						</Col>

						<Col
							md={6}
							className="mb-4"
						>
							<Form.Group
								as={Col}
								md="12"
								controlId="food_ration"
							>
								<Form.Label>Food Ration</Form.Label>
								<Form.Control
									type="number"
									name="food_ration"
									onChange={handleChange}
									value={formState?.food_ration || ""}
								/>
							</Form.Group>
						</Col>

						<Col
							md={6}
							className="mb-4"
						>
							<Form.Group
								as={Col}
								md="12"
								controlId="incentive_amount"
							>
								<Form.Label>Incentive Amount</Form.Label>
								<Form.Control
									type="number"
									name="incentiv"
									onChange={handleChange}
									value={formState?.incentive}
								/>
							</Form.Group>
						</Col>

						<Col
							md={6}
							className="mb-4"
						>
							<Form.Group
								as={Col}
								md="12"
								controlId="khatta_amount"
							>
								<Form.Label>Khatta Amount</Form.Label>
								<Form.Control
									type="number"
									name="khatta_amount"
									onChange={handleChange}
									value={formState?.khatta_amount}
								/>
							</Form.Group>
						</Col>

						<Col
							md={6}
							className="mb-4"
						>
							<Form.Group
								as={Col}
								md="12"
								controlId="loan_amount"
							>
								<Form.Label>Loan Amount</Form.Label>
								<Form.Control
									type="number"
									name="loan_amount"
									onChange={handleChange}
									value={formState?.loan_amount || ""}
								/>
							</Form.Group>
						</Col>

						<Col
							md={6}
							className="mb-4"
						>
							<Form.Group
								as={Col}
								md="12"
								controlId="medical_amount"
							>
								<Form.Label>Medical Amount</Form.Label>
								<Form.Control
									type="number"
									name="medical_amount"
									onChange={handleChange}
									value={formState?.medical_amount}
								/>
							</Form.Group>
						</Col>

						<Col
							md={6}
							className="mb-4"
						>
							<Form.Group
								as={Col}
								md="12"
								controlId="other"
							>
								<Form.Label>Other</Form.Label>
								<Form.Control
									type="number"
									name="other"
									onChange={handleChange}
									value={formState?.other || ""}
								/>
							</Form.Group>
						</Col>

						<Col
							md={6}
							className="mb-4"
						>
							<Form.Group
								as={Col}
								md="12"
								controlId="rent_amount"
							>
								<Form.Label>Rent Amount</Form.Label>
								<Form.Control
									type="number"
									name="rent_amount"
									onChange={handleChange}
									value={formState?.rent_amount || ""}
								/>
							</Form.Group>
						</Col>

						<Col
							md={6}
							className="mb-4"
						>
							<Form.Group
								as={Col}
								md="12"
								controlId="transportation_amount"
							>
								<Form.Label>Transportation Amount</Form.Label>
								<Form.Control
									type="number"
									name="transportation"
									onChange={handleChange}
									value={formState?.transportation}
								/>
							</Form.Group>
						</Col>

						<Col
							md={6}
							className="mb-4"
						>
							<Form.Group
								as={Col}
								md="12"
								controlId="total_dollar"
							>
								<Form.Label>Total Dollar</Form.Label>
								<Form.Control
									type="number"
									name="total_dollar"
									onChange={handleChange}
									value={formState?.total_dollar}
								/>
							</Form.Group>
						</Col>

						<Col
							md={6}
							className="mb-4"
						>
							<Form.Group
								as={Col}
								md="12"
								controlId="total_pkr"
							>
								<Form.Label>Total PKR</Form.Label>
								<Form.Control
									type="number"
									name="total_pkr"
									onChange={handleChange}
									value={formState?.total_pkr || ""}
								/>
							</Form.Group>
						</Col>

						<Col
							md={6}
							className="mb-4"
						>
							<Form.Group
								as={Col}
								md="12"
								controlId="utility_amount"
							>
								<Form.Label>Utility Amount</Form.Label>
								<Form.Control
									type="number"
									name="utility_amount"
									onChange={handleChange}
									value={formState?.utility_amount}
								/>
							</Form.Group>
						</Col>

						<Col
							md={6}
							className="mb-4"
						>
							<Form.Group
								as={Col}
								md="12"
								controlId="scholarship_amount"
							>
								<Form.Label>Scholarship Amount</Form.Label>
								<Form.Control
									type="number"
									name="scholarship_amount"
									onChange={handleChange}
									value={formState.scholarship_amount}
								/>
							</Form.Group>
						</Col>
					</Row>

					{loanFields.map((field) => (
						<Col
							key={field.field}
							md={4}
							className="mb-4"
						>
							<Card>
								<Card.Body>
									<Card.Title>
										<small>{field.text}</small>
									</Card.Title>
									<label
										htmlFor={`file-input-${field.field}`}
										style={{
											width: "100%",
											height: "150px",
											border: "1px dashed #ddd",
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											marginBottom: "10px",
											cursor: "pointer",
											position: "relative",
										}}
									>
										{formState[field.field]?.preview ||
											family?.person?.loan?.[field.field] ? (
											<img
												src={
													formState[field.field]
														?.preview ||
													process.env
														.REACT_APP_IMG_URL +
													family?.person?.loan?.[
													field.field
													]
												}
												alt={`${field.text} preview`}
												style={{
													maxWidth: "100%",
													maxHeight: "100%",
													objectFit: "cover",
												}}
											/>
										) : (
											<i className="material-icons upload-icon">
												{field.icon}
											</i>
										)}
									</label>

									<input
										id={`file-input-${field.field}`}
										type="file"
										style={{ display: "none" }}
										onChange={(e) =>
											handleFileChange(
												e,
												field.field,
												activeSection
											)
										}
										accept="image/*"
									/>
								</Card.Body>
								<Card.Footer>
									<h5>
										{field.text.replace("File", "")} Amount{" "}
										{formState[field.field]?.amount} /-
									</h5>
								</Card.Footer>
							</Card>
						</Col>
					))}
				</>
			);
		} else if (activeSection === "video") {
			return <UploadVideo />;
		} else if (activeSection === "business") {
			return (
				<>
					<Col
						md={6}
						className="mb-4"
					>
						<Form.Group
							as={Col}
							md="12"
							controlId="Donor_id"
						>
							<Form.Label>Donor</Form.Label>
							<select
								name="business_donor"
								value={formState.business_donor || ""}
								onChange={handleChange}
								style={{
									width: "100%",
									color: "black",
									height: "45px",
									padding: "0px 16px",
									borderRadius: "8px",
									border: "1px solid var(--deepBorder)",
									backgroundColor: "var(--lightGray)",
								}}
							>
								<option value="">
									Select Donor ...
								</option>
								{donors?.map((donor) => (
									<option
										value={donor.id}
										key={donor.id}
									>
										{donor.name}
									</option>
								))}
							</select>
						</Form.Group>
					</Col>
					<Col
						md={6}
						className="mb-4"
					>
						<Form.Group
							as={Col}
							md="12"
							controlId="business_type"
						>
							<Form.Label>Business Type</Form.Label>
							<select
								name="business_type_id"
								value={formState.business_type_id || ""}
								onChange={handleChange}
								style={{
									width: "100%",
									color: "black",
									height: "45px",
									padding: "0px 16px",
									borderRadius: "8px",
									border: "1px solid var(--deepBorder)",
									backgroundColor: "var(--lightGray)",
								}}
							>
								<option value="">
									Select Business Type ...
								</option>
								{businessTypes?.map((type) => (
									<option
										value={type.id}
										key={type.id}
									>
										{type.name}
									</option>
								))}
							</select>
						</Form.Group>
					</Col>

					<Col md={6}>
						<Form.Group
							className="mb-3"
							controlId="equipmentCost"
						>
							<Form.Label>
								<small>Equipment Cost</small>
							</Form.Label>
							<Form.Control
								type="number"
								placeholder="Enter Cost"
								name="equipment_cost"
								onChange={handleChange}
								value={formState?.equipment_cost}
							/>
						</Form.Group>
					</Col>

					<Col md={6}>
						<Form.Group
							className="mb-3"
							controlId="estimatedCost"
						>
							<Form.Label>
								<small>Estimated Cost</small>
							</Form.Label>
							<Form.Control
								type="number"
								name="estimated_cost"
								onChange={handleChange}
								placeholder="Estimated Cost"
								value={formState?.estimated_cost}
							/>
						</Form.Group>
					</Col>

					<Col md={6}>
						<Form.Group
							className="mb-3"
							controlId="stockAmount"
						>
							<Form.Label>
								<small>Stock Amount</small>
							</Form.Label>
							<Form.Control
								type="number"
								name="stock_amount"
								onChange={handleChange}
								placeholder="Stock Amount"
								value={formState?.stock_amount}
							/>
						</Form.Group>
					</Col>

					<Col md={6}>
						{" "}
						<Form.Group
							className="mb-3"
							controlId="otherDetails"
						>
							<Form.Label>
								<small>Other Details</small>
							</Form.Label>
							<Form.Control
								type="text"
								name="another_details"
								placeholder="Another Details"
								value={formState?.another_details}
								onChange={handleChange}
							/>
						</Form.Group>
					</Col>
					<Col
						md={6}
						className="mb-4"
					>
						<Button
							onClick={handleSubmitBusiness}
							className="w-100"
							style={{
								backgroundColor: "#077834",
								borderColor: "#077834",
								color: "#fff",
								marginTop: "32px",
							}}
						>
							Save Business Details
						</Button>
					</Col>

					<Row>
						{businessFields.map((field) => {
							const fieldDataP = formState[field.field] || {};
							const fieldData = businessFormState[field.field] || {};
							const serverImage = family?.person?.business?.[field.field] || null;

							// Image URL + cache-buster for preview
							const imgSrc = fieldDataP.preview
								? fieldDataP.preview // local preview (blob URL)
								: serverImage
									? `${process.env.REACT_APP_IMG_URL}/${serverImage}${fieldDataP.cacheBuster ? `?t=${fieldDataP.cacheBuster}` : ""}`
									: null;

							// Rotation logic

							const rotation = fieldData.rotation || 0;

							return (
								<Col key={field.field} md={6} className="mb-4">
									<Card>
										<Card.Body style={{ position: "relative" }}>
											<Card.Title>
												<small>{field.text}</small>
											</Card.Title>

											<label
												htmlFor={`file-input-${field.field}`}
												style={{
													width: "100%",
													height: "350px",
													border: "1px dashed #ddd",
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
													marginBottom: "10px",
													cursor: "pointer",
													position: "relative",
													overflow: "hidden", // 👈 prevent rotated image from spilling out
												}}
											>
												{imgSrc ? (
													<>
														<img
															key={rotation}   // 👈 FIX: forces React to re-render on rotate
															src={imgSrc}
															alt={`${field.text} preview`}
															style={{
																width: "100%",
																height: "100%",
																borderRadius: "8px",
																objectFit: "cover",
																transform: `rotate(${rotation}deg)`,
																transition: "transform 0.3s ease",
															}}
														/>

														{/* Rotate Button */}
														<button
															type="button"
															onClick={(e) => {
																e.stopPropagation();
																handleRotate(field.field);
															}}
															style={{
																position: "absolute",
																bottom: "8px",
																left: "8px",
																background: "#1976D2",
																color: "#fff",
																border: "none",
																borderRadius: "50%",
																width: "30px",
																height: "30px",
																cursor: "pointer",
																display: "flex",
																alignItems: "center",
																justifyContent: "center",
																boxShadow: "0 2px 5px rgba(0,0,0,0.3)",
															}}
															title="Rotate image"
														>
															<FaRedoAlt />
														</button>
													</>
												) : (
													<span style={{ color: "#666" }}>Upload File</span>
												)}
											</label>

											<input
												id={`file-input-${field.field}`}
												type="file"
												style={{ display: "none" }}
												onChange={(e) => handleFileChange(e, field.field, "business")}
												accept="image/*"
											/>
										</Card.Body>
									</Card>
								</Col>
							);
						})}
					</Row>







					<Col
						md={12}
						className="mb-4"
					>
						<Card>
							<Card.Body>
								<Card.Title>
									<small>Family Video</small>
								</Card.Title>

								<div
									style={{
										width: "100%",
										height: "150px",
										border: "1px dashed #ddd",
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										marginBottom: "10px",
										position: "relative",
										backgroundColor: "#f9f9f9",
									}}
								>
									{family?.person?.business?.y_link ? (
										<video
											width="100%"
											height="100%"
											controls
											style={{
												objectFit: "cover",
												borderRadius: "8px",
											}}
										>
											<source
												src={
													process.env
														.REACT_APP_IMG_URL +
													family?.person?.business
														?.y_link
												}
												type="video/mp4"
											/>
											Your browser does not support the
											video tag.
										</video>
									) : (
										<span style={{ color: "#666" }}>
											No Video Uploaded
										</span>
									)}
								</div>
							</Card.Body>
						</Card>
					</Col>
				</>
			);
		}

		return null;
	};

	const handleRotate = async (fieldName) => {
		const imgData = businessFormState[fieldName];
		const newRotation = (imgData?.rotation || 0) + 90;

		// 1️⃣ Update rotation visually for preview or existing image
		setBusinessFormState((prev) => ({
			...prev,
			[fieldName]: {
				...prev[fieldName],
				rotation: newRotation % 360,
			},
		}));

		// 2️⃣ If image exists on the server (not a new preview), call backend API
		const serverImagePath = family?.person?.business?.[fieldName];
		if (serverImagePath && !imgData?.preview) {
			try {
				const response = await axios.post(
					`${process.env.REACT_APP_API_URL}/rotate-image`,
					{
						path: serverImagePath,
						degrees: 90, // always rotate 90° on server
					}
				);

				console.log("Rotation success:", response.data);

				// 3️⃣ Force image refresh to avoid browser cache
				setBusinessFormState((prev) => ({
					...prev,
					[fieldName]: {
						...prev[fieldName],
						cacheBuster: Date.now(), // append timestamp to img src
					},
				}));
			} catch (error) {
				console.error("Rotation error:", error.response?.data || error.message);
			}
		}
	};


	return (
		<Col xl={7}>
			<Row>
				<Col
					md={4}
					lg={4}
				>
					<div
						className={`mc-float-card sm blue ${activeSection === "story" ? "active" : ""
							}`}
						onClick={() => setActiveSection("story")}
						style={{
							cursor: "pointer",
							background:
								"linear-gradient(to right, rgba(0,0,0,0.8), #077834)",
						}}
					>
						<p>Family Story</p>
						<i
							className="material-icons"
							style={{ color: "#077834" }}
						>
							contract_edit
						</i>
					</div>
				</Col>

				<Col
					md={4}
					lg={4}
				>
					<div
						className={`mc-float-card sm blue ${activeSection === "pictures" ? "active" : ""
							}`}
						onClick={() => setActiveSection("pictures")}
						style={{
							cursor: "pointer",
							background:
								"linear-gradient(to right, rgba(0,0,0,0.8), #077834)",
						}}
					>
						<p>Family Pictures</p>
						<i
							className="material-icons"
							style={{ color: "#077834" }}
						>
							add_a_photo
						</i>
					</div>
				</Col>

				{/* video Progress */}
				<Col
					md={4}
					lg={4}
				>
					<div
						className={`mc-float-card sm blue ${activeSection === "video" ? "active" : ""
							}`}
						onClick={() => setActiveSection("video")}
						style={{
							cursor: "pointer",
							background:
								"linear-gradient(to right, rgba(0,0,0,0.8), #077834)",
						}}
					>
						<p>Family Video</p>
						<i
							className="material-icons"
							style={{ color: "#077834" }}
						>
							videocam
						</i>
					</div>
				</Col>

				{/* Family Progress */}
				<Col
					md={4}
					lg={4}
				>
					<div
						className={`mc-float-card sm green ${activeSection === "family" ? "active" : ""
							}`}
						onClick={() => setActiveSection("family")}
						style={{
							cursor: "pointer",
							background:
								"linear-gradient(to right, rgba(0,0,0,0.8), #077834)",
						}}
					>
						<h3 className="text-center">
							{Math.round(family?.family_progress)}%
							<ProgressBar
								className="bar"
								variant="dark"
								now={Math.round(family?.family_progress)}
							/>
						</h3>
						<p>Rescue Progress</p>
						<i
							className="material-icons"
							style={{ color: "#077834" }}
						>
							security
						</i>
					</div>
				</Col>

				{/* Loan Progress */}
				<Col
					md={4}
					lg={4}
				>
					<div
						className={`mc-float-card sm purple ${activeSection === "loan" ? "active" : ""
							}`}
						onClick={() => setActiveSection("loan")}
						style={{
							cursor: "pointer",
							background:
								"linear-gradient(to right, rgba(0,0,0,0.8), #077834)",
						}}
					>
						<h3 className="text-center">
							{Math.round(family?.loan_progress)}%
							<ProgressBar
								className="bar"
								variant="dark"
								now={Math.round(family?.loan_progress)}
							/>
						</h3>
						<p>Payments Progress</p>
						<i
							className="material-icons"
							style={{ color: "#077834" }}
						>
							paid
						</i>
					</div>
				</Col>

				{/* Business Progress */}
				<Col
					md={4}
					lg={4}
				>
					<div
						className={`mc-float-card sm blue ${activeSection === "business" ? "active" : ""
							}`}
						onClick={() => setActiveSection("business")}
						style={{
							cursor: "pointer",
							background:
								"linear-gradient(to right, rgba(0,0,0,0.8), #077834)",
						}}
					>
						<h3 className="text-center">
							{Math.round(family?.business_progress)}%
							<ProgressBar
								className="bar"
								variant="dark"
								now={Math.round(family?.business_progress)}
							/>
						</h3>
						<p>Business Progress</p>
						<i
							className="material-icons"
							style={{ color: "#077834" }}
						>
							add_business
						</i>
					</div>
				</Col>

				{/* Render Active Content */}
				<Col xl={12}>
					<Row>{renderContent()}</Row>
				</Col>
			</Row>
		</Col>
	);
};

export default RescueUpload;
